import axios from '@Services/axios';

export const USER_LOGIN_LOADING = 'user/USER_LOGIN_LOADING';
export const USER_LOGIN_SUCCESS = 'user/USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'user/USER_LOGIN_ERROR';

export const USER_LOGIN_CRM_LOADING = 'user/USER_LOGIN_CRM_LOADING';
export const USER_LOGIN_CRM_SUCCESS = 'user/USER_LOGIN_CRM_SUCCESS';
export const USER_LOGIN_CRM_ERROR = 'user/USER_LOGIN_CRM_ERROR';

export const USER_LOGOUT_LOADING = 'user/USER_LOGOUT_LOADING';
export const USER_LOGOUT_SUCCESS = 'user/USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_ERROR = 'user/USER_LOGOUT_ERROR';

const initialState = {
    firstname: '',
    lastname: '',
    idCommercial: 0,
    idAgence: 0,
    idProfil: 0,
    nomAgence: '',
    latitudeAgence: 0,
    longitudeAgence: 0,

    authToken: '',

    action: null,
    origin: null,

    isLoginInProgress: false,
    isLoginComplete: false,
    isLoginInCrmProgress: false,
    isLoginCrmComplete: false,
    isLogoutInProgress: false,
    isLogoutComplete: false,
    error: ''
};

export function reduxThunkReducer(state = initialState, action) {
    switch (action.type) {
        
        case USER_LOGIN_LOADING: {
            return {
                ...state,
                isLoginInProgress: true,
                isLoginComplete: false,
                error: '',
            };
        }
        case USER_LOGIN_SUCCESS: {
            return {
                ...state,
                isLoginInProgress: false,
                isLoginComplete: true,
                firstname: action?.firstname || '',
                lastname: action?.lastname || '',
                idCommercial: action?.idCommercial || 0,
                idAgence:  action?.idAgence || 0,
                idProfil:  action?.idProfil || 0,
                nomAgence: action?.nomAgence || '',
                latitudeAgence: action?.latitudeAgence || 0,
                longitudeAgence: action?.longitudeAgence || 0,
                authToken: action?.authToken || '',
            };
        }
        case USER_LOGIN_ERROR: {
            return {
                ...state,
                isLoginInProgress: false,
                isLoginComplete: false,
                error: action?.error || '',
            };
        }
        case USER_LOGIN_CRM_LOADING: {
            return {
                ...state,
                isLoginInCrmProgress: true,
                isLoginCrmComplete: false,
                error: '',
            };
        }
        case USER_LOGIN_CRM_SUCCESS: {
            return {
                ...state,
                isLoginInCrmProgress: false,
                isLoginCrmComplete: true,
                firstname: action?.firstname || '',
                lastname: action?.lastname || '',
                idCommercial: action?.idCommercial || 0,
                idAgence:  action?.idAgence || 0,
                idProfil:  action?.idProfil || 0,
                nomAgence: action?.nomAgence || '',
                latitudeAgence: action?.latitudeAgence || 0,
                longitudeAgence: action?.longitudeAgence || 0,
                authToken: action?.authToken || '',
                action: action?.action || null,
                origin: action?.origin || null
            };
        }
        case USER_LOGIN_CRM_ERROR: {
            return {
                ...state,
                isLoginInCrmProgress: false,
                isLoginCrmComplete: false,
                error: action?.error || '',
            };
        }
        case USER_LOGOUT_LOADING: {
            return {
                ...state,
                isLogoutInProgress: true,
                isLogoutComplete: false,
                error: '',
            };
        }
        case USER_LOGOUT_SUCCESS: {
            return {
                ...state,
                isLogoutInProgress: false,
                isLogoutComplete: true,
                isLoginInProgress: false,
                isLoginComplete: false,
                isLoginInCrmProgress: false,
                isLoginCrmComplete: false,
                firstname: '',
                lastname: '',
                idCommercial: 0,
                idAgence: 0,
                idProfil: 0,
                latitudeAgence: 0,
                longitudeAgence: 0,
                nomAgence: '',
                authToken: '',
                action: null,
                origin: null
            };
        }
        case USER_LOGOUT_ERROR: {
            return {
                ...state,
                isLogoutInProgress: false,
                isLogoutComplete: false,
                error: action?.error || '',
            };
        }
        default: {
            return {...state};
        }
    }
}

////////////////////////////////////////////////////////////////////
const URL_API = process.env.REACT_APP_API_ENDPOINT;

export const login = (login, pwd) => {
  return (dispatch) => {
    if (!login || !pwd) {
      dispatch({ 
        type: USER_LOGIN_ERROR,
        error: 'PREPARATION URL = Il manque des paramètres'
      });
    } else {
      dispatch({ 
        type: USER_LOGIN_LOADING
      });
      axios.post(`${URL_API}/connexion`, {identifiant: login, motDePasse: pwd, deviceUUID: ""}).then(
        response => {
          console.log("response TEST", response?.data?.données);

          if (response?.data?.données?.tokenUser?.length > 0) {
            dispatch({ 
              type: USER_LOGIN_SUCCESS,
              firstname: response?.data?.données?.prenomCommercial,
              lastname: response?.data?.données?.nomCommercial,
              idCommercial: response?.data?.données?.idCommercial || 0,
              idAgence: response?.data?.données?.idAgence || 0,
              idProfil: response?.data?.données?.idProfil || 0,
              nomAgence: response?.data?.données?.nomAgence || '',
              latitudeAgence: response?.data?.données?.latitudeAgence || 0,
              longitudeAgence: response?.data?.données?.longitudeAgence || 0,
              authToken: response?.data?.données?.tokenUser || '',
              action: null,
              origin: null
            });
          } else {
            dispatch({ type: USER_LOGIN_ERROR, error: "Erreur lors de la connexion" });
          }
      },
      error => {
        console.log('erreur', error);
        dispatch({ type: USER_LOGIN_ERROR, error: error?.response?.data });
      });
      
    }
  };
};

export const loginFromCrm = (data) => {
  return (dispatch) => {
    if (data?.authToken?.length > 0) {
      dispatch({ 
        type: USER_LOGIN_CRM_LOADING
      });
    
      console.log("loginFromCrm", data);

      dispatch({ 
        type: USER_LOGIN_CRM_SUCCESS,
        firstname: data?.firstname,
        lastname: data?.lastname,
        idCommercial: data?.idCommercial || 0,
        idAgence: data?.idAgence || 0,
        idProfil: data?.idProfil || 0,
        nomAgence: data?.nomAgence || '',
        latitudeAgence: data?.latitudeAgence || 0,
        longitudeAgence: data?.longitudeAgence || 0,
        authToken: data?.authToken || '',
        action: data?.action || null,
        origin: data?.origin || null
      });
    }
  }
};

export const logout = () => {
  return (dispatch) => {
    dispatch({ 
      type: USER_LOGOUT_SUCCESS
    });
  };
};